import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Modal, Row, Space, Typography } from 'antd';
import { isMobile } from 'react-device-detect';
import tlf from '../../../../assets/onboarding/tlf.svg';
import bola from '../../../../assets/onboarding/bola.svg';
import emailIcon from '../../../../assets/documents/emailIcon.png';
import { useParams } from 'react-router-dom';
import { MailAtSign01Icon, SmartPhone01Icon, WhatsappIcon } from 'hugeicons-react';

const { Text } = Typography;

const AgentInformation = ({ name, image, valuesDataAgent, infoAgents, managementCode }) => {
	const { t } = useTranslation();
	let { stage } = useParams();
	const brand = process.env.REACT_APP_BRAND;
	const [showModalAvatar, setShowModalAvatar] = useState(false);
	const renderPhone =
		managementCode === 'sabadell-es' &&
		(stage === 'basic' || stage === 'full' || stage === 'documents')
			? '919 49 94 51'
			: infoAgents?.analyst?.phone || 'No number';
	const renderEmail =
		managementCode === 'sabadell-es' &&
		(stage === 'basic' || stage === 'full' || stage === 'documents')
			? 'portalhipotecas@bancsabadell.com'
			: infoAgents?.analyst?.email || 'No email';
	return (
		<>
			{!isMobile && (
				<div style={{ textAlign: 'center' }}>
					<div
						style={{
							fontSize: 14,
							fontWeight: 600,
							color: '#2F4858',
							marginBottom: 8
						}}>
						{t('details.commercial')}
					</div>

					{image !== undefined && image !== null ? (
						<img src={image} alt="imageAgent" height={58} />
					) : (
						<Avatar size={58} icon={<UserOutlined />} />
					)}

					<div
						style={{
							fontSize: 12,
							fontWeight: 500,
							color: '#2F4858',
							lineHeight: '16px',
							marginTop: 12
						}}>
						{name}
					</div>
					<div
						style={{
							fontSize: 18,
							fontWeight: 700,
							color: '#02C3CD',
							lineHeight: '24px'
						}}>
						{renderPhone}
					</div>
				</div>
			)}
			{isMobile && (
				<>
					{!showModalAvatar ? (
						<div
							style={{ position: 'fixed', bottom: 30, right: 16 }}
							onClick={() => setShowModalAvatar(!showModalAvatar)}>
							<Avatar
								size={80}
								icon={<UserOutlined />}
								src={image}
								style={{ border: '2px solid #006DFF' }}
							/>
							<div
								style={{
									position: 'absolute',
									width: 35,
									height: 25,
									left: 'calc(85% - 78px - 0.36px)',
									top: -10
								}}>
								<img src={bola} alt="bola"></img>
							</div>
						</div>
					) : (
						<Button
							aria-label="Cerrar datos de contacto"
							onClick={() => setShowModalAvatar(!showModalAvatar)}
							style={{
								position: 'fixed',
								bottom: 30,
								right: 16,
								zIndex: 1100,
								width: 80,
								height: 80,
								borderRadius: 40,
								backgroundColor: '#FBFEFF',
								border: '2px solid #006DFF'
							}}>
							<DownOutlined
								style={{
									color: '#006DFF',
									fontSize: 20,
									marginTop: 8,
									marginLeft: 2
								}}
							/>
						</Button>
					)}
				</>
			)}
			{infoAgents && infoAgents.analyst && (
				<Modal
					className="modal-movile-hidden"
					bottom
					transitionName=""
					open={showModalAvatar}
					closable={false}
					maskClosable={true}
					onCancel={() => setShowModalAvatar(!showModalAvatar)}>
					<Space>
						<Avatar size={60} icon={<UserOutlined />} src={image} />
						<Space direction="vertical" style={{ gap: 0 }}>
							<Text style={{ fontSize: 16, color: '#006DFF', fontWeight: 700 }}>
								{name ?? 'No Name'}
							</Text>
							<Text style={{ fontSize: 12, color: '#212121', fontWeight: 400 }}>
								{t('document.personalAnalyst')}
							</Text>
						</Space>
					</Space>
					<hr color="#006DFF" size={1} style={{ margin: '16px 0' }} />
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Text style={{ color: '#212121', fontSize: 14, fontWeight: 400 }}>
							{t('analist.desDude2')}
						</Text>
					</div>
					<Space style={{ gap: 4, marginTop: 16 }}>
						{brand === 'office' ? (
							<SmartPhone01Icon
								color={'#212121'}
								size={18}
								style={{ verticalAlign: 'middle' }}
								aria-hidden="true"
							/>
						) : (
							<a
								href={`https://api.whatsapp.com/send?phone=%2B34${renderPhone}`}
								target="_blank"
								rel="noopener noreferrer"
								aria-label={`Enviar mensaje por WhatsApp al número ${renderPhone}`}
								title={`Enviar WhatsApp a ${renderPhone}`}>
								<WhatsappIcon
									color="#006DFF"
									size={18}
									style={{ verticalAlign: 'middle' }}
									aria-hidden="true"
								/>
							</a>
						)}
						<div style={{ marginTop: 3 }}>
							<Text style={{ color: brand !== 'office' ? '#006DFF' : '#212121' }}>
								{managementCode !== 'sabadell-es' ? renderPhone : '965000380'}
							</Text>
						</div>
					</Space>
					{infoAgents.analyst.showEmail && (
						<Space style={{ gap: 4, marginTop: 8 }}>
							{renderEmail && renderEmail.includes('gibobs') ? null : (
								<a
									href={`mailto:${renderEmail}`}
									target="_blank"
									rel="noopener noreferrer"
									aria-label={`Enviar correo electrónico a ${renderEmail}`}
									title={`Enviar correo a ${renderEmail}`}>
									<MailAtSign01Icon
										color="#006DFF"
										size={18}
										style={{ verticalAlign: 'middle' }}
										aria-hidden="true"
									/>
								</a>
							)}
							<Text style={{ color: '#006DFF' }}>{renderEmail}</Text>
						</Space>
					)}
				</Modal>
			)}
		</>
	);
};

export default AgentInformation;
